import React, { MutableRefObject } from 'react';
import { animated, interpolate } from 'react-spring';

import { AnimState } from '../../animations/animate';

import defaultMapsImage from '../../../../assets/images/placeholders/maps.png';

import styles from './Maps.module.scss';
import { lerp } from '../../../../utils/math';
import { device, insets } from '../../../../utils/device';

type Props = {
    anim: any,
    animStateRef: MutableRefObject<AnimState>
};

export default function Maps({ anim, animStateRef }: Props) {
    function computeInterpolate<T>(states: Record<number, T>): T {
        const value = states[animStateRef.current];
        return value != null ? value : states[AnimState.None];
    }

    return (
        <animated.div
            className={styles.mapsContainer}
            style={{
                transform: interpolate([anim.alpha], alpha => computeInterpolate({
                    [AnimState.SearchToPlayers]: `translateY(${lerp(0, -(45 + (device.isStandalone ? 0 : 30) + insets.top), alpha)}px)`,

                    [AnimState.SearchCalendarToSearchProgress]: `translateY(${lerp(0, -(45 + (device.isStandalone ? 0 : 30) + insets.top), 1 - alpha)}px)`,
                })),
                opacity: interpolate([anim.alpha], alpha => computeInterpolate({
                    [AnimState.None]: 0,

                    [AnimState.Search]: 1,
                    [AnimState.SearchToPlayers]: 1 - alpha,
                    [AnimState.SearchToCourts]: 1 - alpha,
                    [AnimState.SearchToFilter]: 1 - alpha,

                    [AnimState.SearchToCalendarProgress]: 1 - alpha,
                    [AnimState.SearchToCalendar]: 0,

                    [AnimState.SearchCalendarToSearchProgress]: alpha,
                    [AnimState.SearchCalendarToSearch]: 1,

                    [AnimState.CourtsToSearch]: alpha,
                })),
            }}
        >
            <img src={defaultMapsImage} alt="Maps"/>
        </animated.div>
    );
}
